import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class LocalOrderItemDbTableDefinition extends DbTableDefinition {
  tableName = 'local_orderitems';
  tableStructure = `(id INTEGER PRIMARY KEY AUTOINCREMENT,
       label TEXT NOT NULL,
       databag LONGTEXT
      );`;

  constructor() {
    super();
    // Add UpdateStatements to Map
    if (Capacitor.getPlatform() === 'web') {
      this.alterStatements.push({
        table: this.tableName,
        col: 'localStorageInfo',
        type: 'TEXT',
      });
    } else {
      this.updateStatements.set(8, [`ALTER TABLE ${this.tableName} ADD COLUMN localStorageInfo TEXT;`])
    }
  }
}
